module.exports = __webpack_public_path__ + "img/diners.0ff50759.svg";